import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Loader } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import Online from 'components/Online';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Child Components
// @ts-ignore
import ReportsHarvestInspectionsCardGroup from '../../components/ReportsHarvestInspectionsCardGroup';
// @ts-ignore
import ReportsHarvestInspectionsRequest from '../../components/ReportsHarvestInspectionsRequest';
// @ts-ignore
import ReportsHarvestInspectionsTable from '../../components/ReportsHarvestInspectionsTable';
// @ts-ignore
import HarvestTimesheetsAllExportButton from './components/HarvestTimesheetsAllExportButton';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const BinCheckReport = (): React.ReactElement => (
    <ErrorBoundary
        namespace="BinCheckReport"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                Bin Check Report -
                {' '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Online>
            <ReportsHarvestInspectionsRequest />
        </Online>
        <PageTitleAndFilters
            title="Bin Check Report"
            Button={<HarvestTimesheetsAllExportButton />}
            currentEntity
            currentSeason
            pickType
            variety
            varietyMultiple
            entity
        />
        <PageWrapper top={0} bottom={50}>
            <LoadingGate
                namespace="REPORTS_HARVEST_INSPECTIONS_LOAD"
                LoadingComponent={
                    <PageWrapper>
                        <Loader active inline="centered" />
                    </PageWrapper>
                }
            >
                <ErrorGate namespace="REPORTS_HARVEST_INSPECTIONS_LOAD">
                    <Grid>
                        <Grid.Row reversed="computer">
                            <Grid.Column
                                tablet={16}
                                computer={2}
                                stretched
                                style={{ marginBottom: 10 }}
                            >
                                <ReportsHarvestInspectionsCardGroup jobType="TIMESHEET" />
                            </Grid.Column>
                            <Grid.Column
                                tablet={16}
                                computer={14}
                                style={{ marginBottom: 10 }}
                            >
                                <ReportsHarvestInspectionsTable
                                    jobType="TIMESHEET"
                                    defaultCount={10}
                                    defaultSort="numberOfContainers_descending"
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </ErrorGate>
            </LoadingGate>
        </PageWrapper>
    </ErrorBoundary>
);

export default BinCheckReport;
